import { useProfileStore, useSessionStore } from "../stores/UserStore";
import { mainAxios as axios } from "./axios";

export const login = async ({ email, password }) => {
  return axios.post("/users/authentication", { email, password });
};

export const logout = () => {
  useSessionStore.getState().setSession(null);
  useSessionStore.getState().setUserSwitch(null);
  useSessionStore.getState().setAppUrl("");

  useProfileStore.getState().setUnswitchedProfile(null)
  return useProfileStore.getState().setProfile(null);
};

export const signup = async (data) => {
  return axios.post("/users/register", data);
};

export const forgotPwd = async (data) => {
  return axios.put("/users/password/forgot", data);
};

export const resetPwd = async (data) => {
  return axios.put("/users/password/reset", data);
};

export const unlockAccount = async (data) => {
  return axios.put("/users/unlock", data);
};


export const smsConfirmAccount = async ({ code }) => {
  return axios.put("/users/verification/sms/confirm", { code });
};
export const smsConfirmResend = async ({ mobile_phone, mobile_phone_country, domain_saas }) => {
  return axios.post("/users/verification/sms/resend", { mobile_phone, mobile_phone_country, domain_saas });
};
